import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { HelperService } from '../../auxiliares/servicios/helper.service';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard {
  private helperService = inject(HelperService);
  private router = inject(Router);
  private login = inject(LoginService);


  canActivate() {
    if (this.login.isLogged()) {
      return true;
    } else {
      this.helperService.notifWarn('Tenés que iniciar sesión');
      return this.router.parseUrl('/login');
    }
  }

  canActivateChild() {
    if (this.login.isLogged()) {
      return true;
    } else {
      this.helperService.notifWarn('Tenés que iniciar sesión');
      return this.router.parseUrl('/login');
    }
  }
}
